/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Position_Estimated_DescriptionInputs */

const fr_help_position_estimated_description = /** @type {(inputs: Help_Position_Estimated_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculé via les horaires temps réel`)
};

const en_help_position_estimated_description = /** @type {(inputs: Help_Position_Estimated_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculated from real-time schedules`)
};

/**
* | output |
* | --- |
* | "Calculated from real-time schedules" |
*
* @param {Help_Position_Estimated_DescriptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_position_estimated_description = /** @type {((inputs?: Help_Position_Estimated_DescriptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Position_Estimated_DescriptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_position_estimated_description(inputs)
	return en_help_position_estimated_description(inputs)
});